export default __webpack_public_path__ + "videoid_terms.pdf";